import p1_img1 from '../Assets/p1_img1.jpg'
import p1_img2 from '../Assets/p1_img2.webp'
import p1_img3 from '../Assets/p1_img3.jpg'
import p1_img4 from '../Assets/p1_img4.webp'

import p2_img1 from '../Assets/p2_img1.webp'
import p2_img2 from '../Assets/p2_img2.webp'
import p2_img3 from '../Assets/p2_img3.jpg'
import p2_img4 from '../Assets/p2_img4.webp'

import p3_img1 from '../Assets/p3_img1.webp'
import p3_img2 from '../Assets/p3_img2.webp'
import p3_img3 from '../Assets/p3_img3.webp'
import p3_img4 from '../Assets/p3_img4.webp'

import p4_img1 from '../Assets/p4_img1.avif'
import p4_img2 from '../Assets/p4_img2.jpg'
import p4_img3 from '../Assets/p4_img3.jpg'
import p4_img4 from '../Assets/p4_img4.jpg'

import p5_img1 from '../Assets/p5_img1.jpg'
import p5_img2 from '../Assets/p5_img2.webp'
import p5_img3 from '../Assets/p5_img3.webp'
import p5_img4 from '../Assets/p5_img4.webp'

import p6_img1 from '../Assets/p6_img1.webp'
import p6_img2 from '../Assets/p6_img2.webp'
import p6_img3 from '../Assets/p6_img3.webp'
import p6_img4 from '../Assets/p6_img4.webp'

import p7_img1 from '../Assets/p7_img1.webp'
import p7_img2 from '../Assets/p7_img2.webp'
import p7_img3 from '../Assets/p7_img3.jpg'
import p7_img4 from '../Assets/p7_img4.jpg'

import p8_img1 from '../Assets/p8_img1.webp'
import p8_img2 from '../Assets/p8_img2.jpg'
import p8_img3 from '../Assets/p8_img3.jpg'
import p8_img4 from '../Assets/p8_img4.jpg'

import p9_img1 from '../Assets/p9_img1.webp'
import p9_img2 from '../Assets/p9_img2.webp'
import p9_img3 from '../Assets/p9_img3.webp'
import p9_img4 from '../Assets/p9_img4.webp'

import p10_img1 from '../Assets/p10_img1.jpeg'
import p10_img2 from '../Assets/p10_img2.avif'
import p10_img3 from '../Assets/p10_img3.webp'
import p10_img4 from '../Assets/p10_img4.webp'

import p11_img1 from '../Assets/p11_img1.webp'
import p11_img2 from '../Assets/p11_img2.jpg'
import p11_img3 from '../Assets/p11_img3.jpeg'
import p11_img4 from '../Assets/p11_img4.jpeg'

import p12_img1 from '../Assets/p12_img1.avif'
import p12_img2 from '../Assets/p12_img2.avif'
import p12_img3 from '../Assets/p12_img3.webp'
import p12_img4 from '../Assets/p12_img4.avif'

import p13_img1 from '../Assets/p13_img1.jpg'
import p13_img2 from '../Assets/p13_img2.jpeg'
import p13_img3 from '../Assets/p13_img3.webp'
import p13_img4 from '../Assets/p13_img4.webp'

import p14_img1 from '../Assets/p14_img1.webp'
import p14_img2 from '../Assets/p14_img2.webp'
import p14_img3 from '../Assets/p14_img3.jpg'
import p14_img4 from '../Assets/p14_img4.jpg'

import p15_img1 from '../Assets/p15_img1.avif'
import p15_img2 from '../Assets/p15_img2.jpeg'
import p15_img3 from '../Assets/p15_img3.jpg'
import p15_img4 from '../Assets/p15_img4.avif'

import p16_img1 from '../Assets/p16_img1.webp'
import p16_img2 from '../Assets/p16_img2.webp'
import p16_img3 from '../Assets/p16_img3.jpg'
import p16_img4 from '../Assets/p16_img4.jpg'

import p17_img1 from '../Assets/p17_img1.jpeg'
import p17_img2 from '../Assets/p17_img2.avif'
import p17_img3 from '../Assets/p17_img3.webp'
import p17_img4 from '../Assets/p17_img4.avif'

import p18_img1 from '../Assets/p18_img1.webp'
import p18_img2 from '../Assets/p18_img2.jpg'
import p18_img3 from '../Assets/p18_img3.webp'
import p18_img4 from '../Assets/p18_img4.avif'

import p19_img1 from '../Assets/p19_img1.webp'
import p19_img2 from '../Assets/p19_img2.jpg'
import p19_img3 from '../Assets/p19_img3.webp'
import p19_img4 from '../Assets/p19_img4.jpg'

import p20_img1 from '../Assets/p20_img1.jpeg'
import p20_img2 from '../Assets/p20_img2.webp'
import p20_img3 from '../Assets/p20_img3.webp'
import p20_img4 from '../Assets/p20_img4.webp'

let data_product= [
    {
    id: 1,
    category: "women",
    name: "Handloom Cotton Saree with Lotus Motifs and Intricate Border Design",
    image: [p1_img1, p1_img2, p1_img3, p1_img4],
    new_price: 7250.00,
    old_price: 8900.00,
    star: 4,
    reviews: 120,
    description: `
This exquisite handloom cotton saree is meticulously woven from high-quality cotton, offering a soft and breathable fabric that drapes gracefully on all body types. The saree features delicate lotus motifs, carefully designed to evoke a sense of traditional elegance while remaining stylish and contemporary. Its intricate border adds a touch of sophistication, making it suitable for both festive occasions and formal gatherings.

The fabric is lightweight yet durable, ensuring comfort during extended wear. The natural cotton fibers provide excellent breathability, keeping you cool and relaxed in warm weather. Each saree is hand-crafted with attention to detail, ensuring a unique and authentic feel that highlights Sri Lanka's rich textile heritage.

Perfect for weddings, religious ceremonies, or casual family functions, this saree pairs beautifully with a variety of blouses and accessories. Styling it with subtle jewelry can enhance its elegance, while bold accessories can create a modern, chic look. This piece is a versatile addition to any wardrobe, offering both timeless charm and everyday practicality.`
  },
      {
    id: 2,
    category: "women",
    name: "Silk Blend Saree with Golden Zari Work and Modern Floral Patterns",
    image: [p2_img1, p2_img2, p2_img3, p2_img4],
    new_price: 10950.00,
    old_price: 12900.00,
    star: 5,
    reviews: 85,
    description: `
This luxurious silk blend saree is crafted from a smooth and lustrous fabric that combines silk and cotton for the perfect balance of elegance and comfort. The saree is adorned with golden zari work that glimmers subtly under light, enhancing the richness of the fabric. Modern floral patterns are integrated throughout, giving the saree a contemporary aesthetic while retaining traditional charm.

The saree's lightweight nature makes it easy to drape, allowing for graceful movement throughout the day. The fabric’s softness feels gentle on the skin, while the delicate weaving ensures durability and long-lasting use. Each pattern and zari accent is carefully placed to create a harmonious design that draws attention without overwhelming the senses.

Ideal for weddings, festive events, and evening functions, this saree can be paired with statement jewelry to complete a regal look or with minimal accessories for a modern, sophisticated appearance. Its versatility and timeless design make it a staple for women who appreciate both tradition and modern fashion trends.`
  },
  {
    id: 3,
    category: "men",
    name: "Tailored Linen Shirt with Hand-Embroidered Accents for Casual and Formal Occasions",
    image: [p3_img1, p3_img2, p3_img3, p3_img4],
    new_price: 3650.00,
    old_price: 4500.00,
    star: 4,
    reviews: 70,
    description: `
This premium linen shirt is crafted from high-quality, breathable linen, offering exceptional comfort and a crisp appearance throughout the day. The shirt features subtle hand-embroidered accents along the chest and sleeves, adding a refined touch that elevates its overall design. Its tailored fit ensures a flattering silhouette suitable for a range of occasions.

The lightweight fabric allows for excellent air circulation, keeping you cool in warm weather, while the durable stitching ensures the shirt maintains its structure over time. The buttons are carefully chosen to complement the fabric and embroidery, providing a seamless and polished finish.

Perfect for both casual outings and semi-formal events, this shirt can be paired with tailored trousers for a formal look or with jeans for a relaxed, stylish ensemble. Its versatility and attention to detail make it a must-have for men who appreciate both craftsmanship and contemporary fashion.`
  },
  {
    id: 4,
    category: "women",
    name: "Chiffon Long Dress with Flowing Silhouette and Vibrant Floral Prints",
    image: [p4_img1, p4_img2, p4_img3, p4_img4],
    new_price: 5800.00,
    old_price: 7200.00,
    star: 3,
    reviews: 45,
    description: `
This elegant chiffon long dress features a flowing silhouette that moves gracefully with every step. The vibrant floral prints bring a touch of freshness and playfulness, making it ideal for spring and summer outings. The lightweight chiffon fabric ensures breathability and comfort, even during long wear.

The dress is designed with attention to detail, including subtle pleats and a defined waistline that enhances the overall fit. The soft lining provides additional comfort and prevents transparency, allowing you to wear it confidently. Its versatile design allows for both casual and semi-formal styling.

Perfect for brunches, garden parties, or evening events, this dress can be paired with strappy sandals or heels and minimal accessories for a chic, effortless look. Its timeless elegance and comfortable design make it a wardrobe essential for modern women.`
  },
  {
    id: 5,
    category: "kids",
    name: "Cotton Printed Dress with Frilled Sleeves and Comfortable Fit for Girls",
    image: [p5_img1, p5_img2, p5_img3, p5_img4],
    new_price: 2200.00,
    old_price: 2800.00,
    star: 5,
    reviews: 50,
    description: `
This adorable girls' dress is made from soft, breathable cotton, ensuring maximum comfort throughout the day. The bright floral prints and frilled sleeves add a playful charm, making it perfect for both casual and festive occasions. The dress allows free movement, making it ideal for active kids.

The high-quality cotton fabric is gentle on sensitive skin and provides durability, allowing for repeated washing and wear without losing its color or shape. The careful stitching ensures a long-lasting garment that maintains its form and elegance.

Ideal for birthdays, family outings, or school events, this dress can be paired with matching accessories and comfortable footwear. Its charming design, combined with practical comfort, makes it a favorite choice for parents looking for stylish yet wearable clothing for their children.`
  },
      {
    id: 6,
    category: "women",
    name: "Handloom Cotton Saree with Floral Borders and Elegant Pallu",
    image: [p6_img1, p6_img2, p6_img3, p6_img4],
    new_price: 7800.00,
    old_price: 9100.00,
    star: 5,
    reviews: 80,
    description: `
This handloom cotton saree is crafted from premium cotton that feels soft and breathable, making it perfect for all-day comfort. The saree features delicate floral borders and an elegantly patterned pallu, reflecting timeless craftsmanship. The handwoven texture gives each piece a unique, artisanal charm.

The lightweight fabric ensures easy draping, while maintaining a graceful flow and drape throughout wear. Its durability allows repeated use without compromising the fabric quality. Each saree is meticulously woven to ensure consistency and attention to detail.

Ideal for cultural events, casual gatherings, or formal family functions, this saree can be paired with minimalist jewelry for a sophisticated look or with statement accessories for a festive appearance. Its classic design combined with comfort makes it a versatile wardrobe essential.`
  },
  {
    id: 7,
    category: "men",
    name: "Premium Cotton Shirt with Classic Collar and Slim Fit",
    image: [p7_img1, p7_img2, p7_img3,p7_img4],
    new_price: 4200.00,
    old_price: 5000.00,
    star: 4,
    reviews: 60,
    description: `
This premium cotton shirt is tailored from soft, breathable cotton fabric, ensuring comfort during long hours of wear. Featuring a classic collar and slim fit design, it offers a polished and modern look suitable for both office and casual settings. The fine stitching and smooth finish highlight the high-quality craftsmanship.

The shirt is designed to maintain its shape even after repeated washes, ensuring longevity and durability. The fabric’s natural breathability keeps you cool, making it ideal for warm climates. Its versatile design allows it to be worn tucked or untucked, depending on the occasion.

Pair it with tailored trousers for formal events or jeans for a relaxed, stylish appearance. Its timeless style, comfort, and high-quality material make it a staple in any man’s wardrobe.`
  },
  {
    id: 8,
    category: "kids",
    name: "Boys Cotton Kurta with Button Detailing and Comfortable Fit",
    image: [p8_img1, p8_img2, p8_img3, p8_img4],
    new_price: 2600.00,
    old_price: 3200.00,
    star: 5,
    reviews: 45,
    description: `
This boys’ cotton kurta is made from soft, breathable cotton, ensuring maximum comfort and ease of movement for active kids. It features subtle button detailing and a classic design that combines traditional charm with modern style. The lightweight fabric makes it suitable for all-day wear, whether at school, family events, or casual outings.

The kurta is carefully stitched for durability, maintaining its shape and appearance even after multiple washes. The breathable fabric keeps children comfortable in warm weather, while the relaxed fit allows freedom of movement.

Perfect for festive occasions, cultural events, or casual gatherings, this kurta can be paired with cotton pants or jeans for a versatile look. Its thoughtful design, quality fabric, and ease of wear make it an ideal choice for parents seeking both style and practicality.`
  },
  {
    id: 9,
    category: "women",
    name: "Georgette Saree with Embroidered Motifs and Sheer Pallu",
    image: [p9_img1, p9_img2, p9_img3, p9_img4],
    new_price: 9500.00,
    old_price: 11200.00,
    star: 5,
    reviews: 70,
    description: `
This georgette saree is crafted from lightweight, flowing fabric that drapes elegantly around the body. The saree is adorned with embroidered motifs and a sheer pallu that adds a delicate, sophisticated touch. Each detail is carefully executed to create a harmonious and stylish design.

The soft fabric ensures all-day comfort, while the embroidery enhances its festive appeal. The saree’s lightweight nature allows for easy draping and graceful movement. Its durability ensures that it remains a cherished piece in your wardrobe for years to come.

Ideal for weddings, parties, or festive celebrations, this saree can be paired with statement jewelry or minimal accessories depending on the occasion. Its combination of elegance, comfort, and intricate embroidery makes it a standout piece for special events.`
  },
  {
    id: 10,
    category: "accessories",
    name: "Handcrafted Beaded Necklace with Adjustable Closure and Vibrant Accents",
    image: [p10_img1, p10_img2, p10_img3, p10_img4],
    new_price: 1750.00,
    old_price: 2100.00,
    star: 4,
    reviews: 35,
    description: `
This handcrafted beaded necklace features vibrant beads meticulously strung together to create a bold and colorful accessory. The adjustable closure allows for a comfortable fit on any neck size, ensuring ease of wear. Each necklace is uniquely crafted, giving it an artisanal and one-of-a-kind appeal.

The lightweight design ensures it can be worn throughout the day without discomfort. The combination of colors and patterns makes it a versatile accessory that complements both casual and ethnic outfits. Its durability ensures that it maintains its beauty even after frequent use.

Perfect for parties, casual outings, or cultural events, this necklace can be paired with matching bracelets or earrings to create a cohesive look. Its vibrant design, comfort, and craftsmanship make it a must-have accessory for any fashion enthusiast.`
  },
      {
    id: 11,
    category: "women",
    name: "Silk Blend Saree with Traditional Gold Zari and Modern Motifs",
    image: [p11_img1, p11_img2, p11_img3, p11_img4],
    new_price: 11500.00,
    old_price: 13500.00,
    star: 5,
    reviews: 88,
    description: `
This silk blend saree combines the richness of traditional gold zari work with modern motifs to create a stunning visual appeal. The fabric is smooth and lustrous, ensuring an elegant drape that enhances the wearer’s silhouette. Each motif is carefully woven, making every saree unique.

The lightweight silk blend ensures comfort for extended wear while retaining a luxurious feel. The zari work adds a subtle shimmer that catches the light beautifully, making it perfect for festive occasions or evening events.

Pair this saree with delicate jewelry and elegant footwear to complete the ensemble. Its blend of tradition and contemporary style makes it a versatile choice for weddings, cultural events, and formal gatherings.`
  },
  {
    id: 12,
    category: "men",
    name: "Formal Cotton Shirt with Slim Fit and Minimalist Design",
    image: [p12_img1, p12_img2, p12_img3,p12_img4],
    new_price: 4300.00,
    old_price: 5200.00,
    star: 4,
    reviews: 55,
    description: `
This formal cotton shirt is designed with a slim fit and minimalist styling for a modern and professional appearance. Crafted from high-quality breathable cotton, it offers comfort even during long office hours. The smooth fabric and precise stitching highlight its premium craftsmanship.

The shirt maintains its shape and crispness after repeated washes, ensuring long-term durability. The slim fit enhances the overall silhouette while allowing ease of movement. Its versatile design allows it to be paired with trousers for formal occasions or jeans for smart-casual outings.

Ideal for office wear, business meetings, or formal gatherings, this shirt provides a polished and stylish look. Its simplicity combined with quality materials makes it a wardrobe staple for any man.`
  },
  {
    id: 13,
    category: "kids",
    name: "Girls Party Frock with Layered Tulle Skirt and Sparkling Sequins",
    image: [p13_img1, p13_img2, p13_img3, p13_img4],
    new_price: 3100.00,
    old_price: 3800.00,
    star: 5,
    reviews: 48,
    description: `
This playful party frock for girls features a layered tulle skirt that creates a voluminous and charming silhouette. The bodice is adorned with sparkling sequins, adding a festive touch and elegance. Soft cotton lining ensures comfort and prevents irritation on sensitive skin.

The lightweight design allows for freedom of movement while maintaining the structure of the dress. Durable stitching ensures it withstands active play and repeated use. Its breathable fabric keeps children cool during parties and special occasions.

Perfect for birthdays, family celebrations, or festive events, this frock can be paired with a matching hair accessory and comfortable footwear. The combination of style, sparkle, and comfort makes it a favorite choice for young girls.`
  },
  {
    id: 14,
    category: "women",
    name: "Chiffon Maxi Dress with Floral Prints and Flowing Silhouette",
    image: [p14_img1, p14_img2, p14_img3, p14_img4],
    new_price: 6200.00,
    old_price: 7400.00,
    star: 4,
    reviews: 60,
    description: `
This elegant chiffon maxi dress features vibrant floral prints that add a refreshing touch to your wardrobe. The flowing silhouette allows graceful movement and creates a flattering fit for various body types. Soft, lightweight fabric ensures comfort throughout the day or evening.

The dress is designed with subtle pleats and a defined waistline to enhance the overall look. The lining provides opacity and prevents transparency, ensuring confidence and comfort. Its breathable nature makes it ideal for warm weather outings.

Perfect for brunches, garden parties, or casual events, this dress can be styled with strappy sandals and minimal accessories for a chic and effortless look. Its combination of comfort, elegance, and print makes it a versatile wardrobe essential.`
  },
  {
    id: 15,
    category: "accessories",
    name: "Handmade Brass Bracelet with Intricate Engraving and Adjustable Chain",
    image: [p15_img1, p15_img2, p15_img3,p15_img4],
    new_price: 1450.00,
    old_price: 1800.00,
    star: 4,
    reviews: 38,
    description: `
This handcrafted brass bracelet showcases intricate engraving that highlights artisanal craftsmanship. The adjustable chain ensures a perfect fit for any wrist size, providing both comfort and style. Each bracelet is unique, offering a personalized, one-of-a-kind accessory.

Lightweight yet durable, the bracelet can be worn all day without discomfort. The detailed engraving and polished finish make it suitable for casual, festive, or semi-formal occasions. Its timeless design allows it to complement a variety of outfits.

Pair it with matching earrings or rings to create a cohesive accessory ensemble. This bracelet combines elegance, durability, and traditional craftsmanship, making it an ideal addition to any jewelry collection.`
  },
    {
    id: 16,
    category: "women",
    name: "Georgette Saree with Embroidered Border and Elegant Pallu",
    image: [p16_img1, p16_img2, p16_img3, p16_img4],
    new_price: 9700.00,
    old_price: 11200.00,
    star: 5,
    reviews: 82,
    description: `
This georgette saree is designed for elegance and comfort, featuring an embroidered border and a delicately patterned pallu. The lightweight fabric drapes gracefully, creating a flowing silhouette that enhances the wearer’s presence. Fine embroidery work adds a sophisticated and festive touch.

The soft fabric ensures all-day comfort, while the saree’s structure allows effortless draping and movement. Each piece is carefully woven, highlighting artisanal craftsmanship and attention to detail. The vibrant yet subtle patterns make it versatile for various occasions.

Perfect for weddings, religious ceremonies, or evening events, this saree pairs beautifully with minimal or statement jewelry. Its combination of elegance, comfort, and intricate embroidery makes it a wardrobe staple for women seeking both tradition and modern style.`
  },
  {
    id: 17,
    category: "men",
    name: "Cotton Linen Blend Shirt with Classic Collar and Button Detailing",
    image: [p17_img1, p17_img2, p17_img3,p17_img4],
    new_price: 4450.00,
    old_price: 5300.00,
    star: 4,
    reviews: 60,
    description: `
This premium cotton-linen blend shirt combines comfort and style, offering breathability and a smooth texture for all-day wear. The classic collar and subtle button detailing provide a timeless, polished look suitable for both office and casual occasions. The slim fit ensures a contemporary and flattering silhouette.

Durable stitching and high-quality fabric make this shirt resilient to repeated wear and washing. The breathable material ensures comfort in warm climates while maintaining a crisp appearance. Its versatile design allows it to be worn tucked or untucked depending on the setting.

Pair it with tailored trousers for formal events or casual jeans for a relaxed, stylish look. This shirt’s blend of quality, comfort, and style makes it a must-have for modern men.`
  },
  {
    id: 18,
    category: "kids",
    name: "Boys Party Kurta with Embroidered Neckline and Comfortable Cotton Fabric",
    image: [p18_img1, p18_img2, p18_img3, p18_img4],
    new_price: 2700.00,
    old_price: 3400.00,
    star: 5,
    reviews: 42,
    description: `
This boys’ party kurta is crafted from soft, breathable cotton to provide maximum comfort and ease of movement. The embroidered neckline adds a festive and stylish touch, making it ideal for cultural events or family gatherings. The kurta’s lightweight design allows children to move freely without restriction.

Durable stitching ensures the kurta retains its shape and quality even after multiple washes. The cotton fabric is gentle on sensitive skin while maintaining an elegant appearance. The classic design offers versatility for casual and formal occasions alike.

Pair with cotton pants or churidars to complete a traditional look. Its combination of comfort, style, and craftsmanship makes it a favorite choice for parents seeking high-quality festive wear for their children.`
  },
  {
    id: 19,
    category: "women",
    name: "Chiffon Maxi Dress with Printed Patterns and Flared Hemline",
    image: [p19_img1, p19_img2, p19_img3, p19_img4],
    new_price: 6500.00,
    old_price: 7800.00,
    star: 4,
    reviews: 65,
    description: `
This chiffon maxi dress features vibrant printed patterns and a flared hemline for a flowing, feminine silhouette. Lightweight and breathable, the fabric ensures comfort throughout the day while maintaining a graceful drape. The design combines casual elegance with a contemporary style.

The dress includes subtle pleating and lining for both structure and opacity, allowing confident wear for various occasions. Its soft texture and flowing design make it ideal for brunches, parties, or evening outings. The versatile print and cut make it a stylish choice for multiple seasons.

Pair it with sandals or heels and minimal jewelry for a chic, effortless look. Its combination of comfort, movement, and print make it an essential addition to a modern wardrobe.`
  },
  {
    id: 20,
    category: "accessories",
    name: "Handcrafted Beaded Earrings with Lightweight Design and Colorful Accents",
    image: [p20_img1, p20_img2, p20_img3,p20_img4],
    new_price: 1550.00,
    old_price: 1900.00,
    star: 4,
    reviews: 37,
    description: `
These handcrafted beaded earrings feature colorful beads carefully arranged to create a vibrant and unique accessory. The lightweight design ensures comfortable wear for extended periods, while the intricate craftsmanship highlights attention to detail. Each pair is unique, reflecting artisanal skill.

Durable and versatile, these earrings complement a variety of outfits from casual to traditional attire. The playful color combination allows them to stand out while maintaining elegance. They are perfect for daily wear, festive events, or parties.

Pair them with matching bracelets or necklaces to create a cohesive look. Their combination of style, comfort, and craftsmanship makes them a must-have accessory for any fashion-conscious individual.`
  },
    
]
export default data_product;